// Step 1, `#foundation` "Ask flow" gallery: sentence entry. No suggestion
// list is wired to real data (no history endpoint exists), so this renders
// the input only -- inventing a recent-queries list would be fabricated data.
import { useState, type FormEvent } from 'react';

export function AskEntry({
  initialSentence = '',
  onSubmit,
}: {
  initialSentence?: string;
  onSubmit: (sentence: string) => void;
}) {
  const [sentence, setSentence] = useState(initialSentence);

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (sentence.trim()) onSubmit(sentence.trim());
  }

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-2 rounded-lg border-2 border-link bg-background px-3 py-2.5">
      <span aria-hidden="true" className="font-mono text-sm">
        ›
      </span>
      <input
        autoFocus
        value={sentence}
        onChange={(event) => setSentence(event.target.value)}
        placeholder="business trip to LA in July"
        aria-label="Ask MoneySkyline"
        className="flex-1 bg-transparent text-sm outline-none"
      />
      <button type="submit" className="min-h-11 rounded-md bg-primary px-3 text-sm text-primary-foreground">
        Preview
      </button>
    </form>
  );
}

export default AskEntry;
